import state from "./moduleHullInsuranceReportViewState.js";
import mutations from "./moduleHullInsuranceReportViewMutations.js";
import actions from "./moduleHullInsuranceReportViewActions.js";
import getters from "./moduleHullInsuranceReportViewGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
